import axios from "axios";

export default axios.create({ baseURL: "https://api2.otb-portal.com/api" });
